<template>
  <div class="mt-5">
    <label
      :for="inputId"
      :class="{
        'text-red-400': phoneNumberError,
        'text-black-800': !phoneNumberError
      }"
      class="mb-2 text-xs font-medium"
    >
      {{ label }}
    </label>
    <vue-tel-input
      ref="vueTelInput"
      id="phoneNumberInput"
      v-model="phoneNumber"
      :autoFormat="true"
      :dropdownOptions="dropdownOptions"
      :inputOptions="inputOptions"
      :input-class="'form-control'"
      :input-id="inputId"
      :class="{ 'custom-vue-tel-input': true, error: phoneNumberError }"
      @click="replaceSearchBarPlaceHolder"
      @country-changed="handleCountryChange"
      @open="openDropDown"
      @close="closeDropDown"
      @blur="onBlur"
    >
      <template v-slot:arrow-icon>
        <img
          :src="dropDownImageUrl"
          :alt="dropDownSymbolAlt"
          :style="dropDownIconStyle"
        />
      </template>
    </vue-tel-input>
    <div v-if="phoneNumberError" class="text-red-400 text-xs mt-2">
      {{ phoneNumberError }}
    </div>
  </div>
</template>

<script>
import { VueTelInput } from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';
import { PRECHAT_COUNTRY_CODE_SEARCH_BOX_PALCEHOLDER, PRECHAT_PHONE_NUMBER_ERROR_MESSAGE, PRECHAT_PHONE_NUMBER_INPUT_PALCEHOLDER } from '../../helpers/constants';
const libphonenumber = require('google-libphonenumber');
const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();
const phoneNumberFormat = libphonenumber.PhoneNumberFormat;

export default {
  name: 'FormTelInput',
  components: {
    VueTelInput
  },
  props: {
    value: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    dropDownImageUrl: {
      type: String,
      required: true
    },
    dropDownSymbolAlt: {
      type: String,
      default: 'Image'
    },
    inputId: {
      type: String,
      default: 'phoneNumberInput'
    }
  },
  data() {
    return {
      phoneNumber: this.value,
      dropdownOptions: {
        showFlags: true,
        showDialCodeInList: true,
        dropdownClass: 'custom-dropdown-class',
        showSearchBox: true,
        showDialCodeInSelection: true
      },
      inputOptions: {
        placeholder: PRECHAT_PHONE_NUMBER_INPUT_PALCEHOLDER,
        maxlength: 50
      },
      phoneNumberError: '',
      countryCode: null,
      countryDialCode: null,
      formattedPhoneNumber: null,
      isOpen: false,
    };
  },
  computed: {
    dropDownIconStyle() {
      return {
        transform: this.isOpen ? 'rotate(180deg)' : 'rotate(0deg)'
      };
    }
  },
  mounted() {
    const dropdown = this.$refs.vueTelInput.$el.querySelector(
      '.custom-vue-tel-input .vti__dropdown'
    );
    if (dropdown) {
      dropdown.addEventListener('click', this.replaceSearchBarPlaceHolder);
      dropdown.addEventListener('input', this.replaceSearchBarPlaceHolder);
    }
  },
  beforeDestroy() {
    const dropdown = this.$refs.vueTelInput.$el.querySelector(
      '.custom-vue-tel-input .vti__dropdown'
    );
    if (dropdown) {
      dropdown.removeEventListener('click', this.replaceSearchBarPlaceHolder);
      dropdown.removeEventListener(
        'input',
        this.replaceSearchBarPlaceHolder
      );
    }
  },
  watch: {
    phoneNumber() {
      this.phoneNumberError = ''
      this.$emit('input', this.phoneNumber);
    }
  },
  methods: {
    onBlur() {
        this.$emit('onBlur');
        this.phoneNumberError = this.phoneNumber ? '' : PRECHAT_PHONE_NUMBER_ERROR_MESSAGE.EMPTY_PHONE_NUMBER;
    },
    validatePhoneNumber(phoneNumber) {
      const CCode = this.countryCode;
      try {
        const number = phoneUtil.parseAndKeepRawInput(phoneNumber, CCode);
        const isValid = phoneUtil.isValidNumberForRegion(number, CCode);
        if (!isValid) {
          const exampleNumber = phoneUtil.getExampleNumber(CCode);
          const formattedExampleNumber = phoneUtil.format(
            exampleNumber,
            phoneNumberFormat.INTERNATIONAL
          );
          this.phoneNumberError = `${PRECHAT_PHONE_NUMBER_ERROR_MESSAGE.EXAMPLE_NUMBER} ${formattedExampleNumber}`;
          return {
            isValid: false,
            error: this.phoneNumberError
          };
        }
        this.phoneNumberError = '';
        const formattedNumber = phoneUtil.format(
          number,
          phoneNumberFormat.INTERNATIONAL
        );
        this.formattedPhoneNumber = formattedNumber.replace(/[\s-]+/g, '');        
        return { isValid: true, formattedNumber };
      } catch (error) {
        let exampleNumber;
        try {
          exampleNumber = phoneUtil.getExampleNumber(CCode);
          const formattedExampleNumber = phoneUtil.format(
            exampleNumber,
            phoneNumberFormat.INTERNATIONAL
          );
          this.phoneNumberError = `${PRECHAT_PHONE_NUMBER_ERROR_MESSAGE.EXAMPLE_NUMBER} ${formattedExampleNumber}`;
        } catch (exampleError) {
          this.phoneNumberError = `${PRECHAT_PHONE_NUMBER_ERROR_MESSAGE.INVALID_NUMBER}`
        }
        return { isValid: false, error: this.phoneNumberError };
      }
    },
    handleCountryChange(country) {
      this.countryCode = country.iso2;
      this.countryDialCode = country.dialCode;
      this.phoneNumberError = '';
      this.$emit('countryChanged', this.countryCode);
    },
    openDropDown() {
      this.isOpen = true;
    },
    closeDropDown() {
      this.isOpen = false;
    },
    replaceSearchBarPlaceHolder() {
      const searchBox = this.$refs.vueTelInput.$el.querySelector(
        '.custom-vue-tel-input .vti__search_box'
      );
      if (searchBox) {
        searchBox.placeholder = PRECHAT_COUNTRY_CODE_SEARCH_BOX_PALCEHOLDER;
      }
    },
  }
};
</script>
